import { useLocale } from 'shared-ui';
import * as yup from 'yup';

import { AppMessages } from 'i18n/messages';

export const useBlockCardValidation = () => {
  const { formatMessage } = useLocale();

  const schema = yup.object().shape({
    powodBlokady: yup
      .string()
      .max(60, formatMessage({ id: AppMessages['card.block.validation.max'] }))
      .required(formatMessage({ id: AppMessages['card.block.validation.required'] })),
  });

  return { schema };
};
